import { gql } from '@apollo/client';

// Fragment for common importer fields
export const IMPORTER_FIELDS_FRAGMENT = gql`
  fragment ImporterFields on Importer {
    id
    version
    name
    alternateName
    description
    addressList {
      cityName
      country
      countrySubDivision
      countrySubDivisionName
      externalReference {
        id
        customerId
      }
      houseNumber
      houseNumberAddition
      line
      postCode
      type
      streetName
      postOfficeBox
    }
    phone {
      country
      extension
      number
    }
    email
    pointOfContact {
      email
      name
      phone {
        country
        extension
        number
      }
    }
    identifiers {
      identification
      identificationType
    }
    owners {
      customerId
      type
    }
    businessStructure
    docReadinesses {
      id
      programType
    }
  }
`;

export const UPDATE_IMPORTER = gql`
  mutation UpdateImporterRecord(
    $id: ID!
    $input: UpdateImporterInput!
    $version: Int!
  ) {
    updateImporter(id: $id, input: $input, version: $version) {
      record {
        id
        version
      }
    }
  }
`;

export const UPDATE_IMPORTER_ENTITY = gql`
  mutation UpdateImporterEntity(
    $id: ID!
    $input: UpdateImporterEntityInput!
    $version: Int!
  ) {
    updateImporterEntity(id: $id, input: $input, version: $version) {
      record {
        id
        version
      }
    }
  }
`;

export const IMPORTER = gql`
  ${IMPORTER_FIELDS_FRAGMENT}
  query ImporterDetail($importerId: ID!) {
    importer(id: $importerId) {
      ...ImporterFields
      dpsRecord {
        id
        version
        overallDpsStatus
        dpsStatus {
          code
          time
        }
        updated {
          time
        }
      }
      usIor {
        id
        version
        status
        updated {
          time
        }
        activations {
          status
          customsBroker {
            id
          }
        }
        addressList {
          cityName
          country
          countrySubDivision
          countrySubDivisionName
          houseNumber
          houseNumberAddition
          line
          postCode
          postOfficeBox
          streetName
          type
        }
        identifiers {
          identification
          identificationType
        }
        isResident
        pointOfContact {
          email
          name
          phone {
            number
            extension
            country
          }
          title
        }
        docReadinessId
        continuousBonds {
          future {
            amount
            effectiveDate
            number
            suretyCode
          }
          past {
            amount
            effectiveDate
            number
            suretyCode
          }
          present {
            amount
            effectiveDate
            number
            suretyCode
          }
        }
        updated {
          time
        }
        dpsRecord {
          id
          overallDpsStatus
          dpsStatus {
            code
            time
          }
          updated {
            time
          }
        }
      }
      importerEntities {
        nodes {
          id
          version
          addressList {
            cityName
            country
            countrySubDivision
            countrySubDivisionName
            externalReference {
              id
              customerId
            }
            houseNumber
            houseNumberAddition
            line
            postCode
            postOfficeBox
            streetName
            type
          }
          updated {
            time
          }
          countryCode
          bonds {
            present {
              referenceIdentifier
              typeCode
              amount
              effectiveDate
              renewalDate
              terminationDate
              surety {
                name
                code
              }
            }
            past {
              referenceIdentifier
              typeCode
              amount
              effectiveDate
              renewalDate
              terminationDate
              surety {
                name
                code
              }
            }
            future {
              referenceIdentifier
              typeCode
              amount
              effectiveDate
              renewalDate
              terminationDate
              surety {
                name
                code
              }
            }
          }
          isResident
          status
          identifiers {
            identification
            identificationType
          }
          program {
            docReadiness {
              id
            }
          }
          pointOfContact {
            email
            name
            phone {
              number
              extension
              country
            }
            title
          }
          dpsRecord {
            id
            version
            overallDpsStatus
            dpsStatus {
              code
              time
            }
            updated {
              time
            }
          }
          externalValidations {
            response {
              validationResult
              companyDetails {
                name
              }
            }
            identification {
              identificationType
            }
            validationDate
          }
          importer {
            ...ImporterFields
          }
        }
      }
    }
  }
`;
